//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from 'react';
import context from 'context/context';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

// custom pages
import Table from 'components/Table/Table';
import AuthorizedMembersAPI from 'apis/authorizedMembers/authorizedMembers';
import useDebounce from 'helpers/useDebounce';
import { authorizedMembersstyles } from './styles';
import Loader from 'components/Loader/Loader';
import access, { editAccess } from 'config/access';
import searchIcon from 'assets/img/Search_Icon.png';
import { blockInvalidCharForText } from 'helpers/blockInvalidCharForText';

// material-ui
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Badge from '@material-ui/core/Badge';

// material-ui icons
import Grid from '@material-ui/core/Grid';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import editIcon from 'assets/img/editIcon.png';
import { validateEmail } from 'helpers/validateEmail';

//analytics 
import { logEvent } from 'helpers/analytics';
import {useTrackWithGTM} from 'helpers/gtm';

import { useTranslation } from 'react-i18next';

// custom TextField
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '##D3D3D3',
    },
    '& .MuiFormLabel-root': {
      color: '#707070',
    },
    '& .MuiInputBase-input': {
      color: '#707070',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#707070!important',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#707070',
      },
      '&:hover fieldset': {
        borderColor: '#707070',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#707070',
      },
      '&.MuiOutlinedInput-root': {
        borderRadius: 20,
      },
      '&.MuiOutlinedInput-root': {
        marginTop: 0,
        borderRadius: 20,
        background: '#ededed',
      },
    },
  },
})(TextField);

export default function AuthorizedMembers() {
  const { state, dispatch } = useContext(context);
  const { getAuthorizedmembers, filter, search, getRoles, update } =
    AuthorizedMembersAPI();
  const classes = authorizedMembersstyles();
  const history = useHistory();
  const { t, i18n } = useTranslation();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const searchBounceValues = useDebounce(searchValue);
  const [errorText, setErrorText] = useState('');

  const [states, setstates] = useState({
    filter: false,
    is_active: null,
    filterRole: '',
    roles: [],
    editId: '',
    isEdit: false,
    isActive: false,
    role: '',
    loyaltyId: '',
    userId: '',
  });

  const [editObj, setEditObj] = useState({});
  const [updateObj, setUpdateObj] = useState({});
  const { trackWithGTM } = useTrackWithGTM();

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    handleMarketingAdminFunc();
  }, [state.ALA]);

  const handleMarketingAdminFunc = () => {
    if (access["myDashboard"]["loyalty"][state.userInfo.role]) {
      if (state?.ALA && Object.keys(state?.ALA).length > 0) {
        return;
      }
      return history.push("/dashboard/loyalty");
    }
  };

  useEffect(() => {
    // 🔹 Log page view
    logEvent({
      event_type: "page_view",
      event_name: "authorized-members",
      user_id: state?.userInfo?.user_id,
      session_id: state?.userInfo?.session_id,
    });
  }, []);


  // handling api calls
  useEffect(() => {
    if (state.ALA && Object.keys(state.ALA).length > 0) {
      states.filter ||
        states.filterRole.length > 0 ||
        typeof states.is_active === 'boolean'
        ? handleFilter()
        : searchValue.length > 0
          ? handleSearch()
          : handleGetAuthorizedMembers();
    }
  }, [state.ALA, offset]);

  useEffect(() => {
    dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'Authorized Members'] });
  }, []);

  // roles api func
  useEffect(() => {
    handleGetRoles();
  }, []);

  // handling search api
  useEffect(() => {
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
    if (states.isEdit) {
      setStates({
        editId: '',
        isEdit: false,
        isActive: null,
        role: '',
      });
    }
  };

  // roles api func
  const handleGetRoles = async () => {
    try {
      let res = await getRoles();
      if (res) {
        if (access['authorizedMembers']['admins'][state.userInfo.role]) {
          setStates({ roles: res.data });
          return;
        } else {
          setStates({
            roles: res.data.filter(
              (r) =>
                r.role_name !== "Marketing Admin" || r.role_name !== "IT Admin" || r.role_name !== "Observer"
            ),
          });
        }
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const addRoles = (roles, role) => {
    let index = roles.findIndex((r) => r.role_name === role);
    if (index === -1) {
      return <MenuItem value={role}>{role}</MenuItem>;
    }
    return;
  };

  // authorized members api func
  const handleGetAuthorizedMembers = async () => {
    try {
      let values;
      values = {
        loyaltyId: state.ALA?.loyalty_id,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await getAuthorizedmembers(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        dispatch({ type: 'SET_LOADING', payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // search api func
  const handleSearch = async () => {
    setStates({ is_active: null, filterRole: '', filter: false });
    try {
      let values;

      if (!searchValue.replace(/\s/g, '').length) {
        return;
      }
      values = {
        searchValue: searchValue,
        loyaltyId: state.ALA?.loyalty_id,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await search(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        dispatch({ type: 'SET_LOADING', payload: false });
        return;
      }
      dispatch({ type: 'SET_LOADING', payload: false });
      setData([]);
    } catch (e) {
      console.log({ e });
    }
  };

  // filter api func
  const handleFilter = async () => {
    logEvent({
      event_type: "filter-authorized-members",             
      event_name: "Button_Click",
      user_id: state?.userInfo?.user_id,
      session_id: state?.userInfo?.session_id,
      page_url: window.location.pathname,
    });
    trackWithGTM({
      database: state?.userInfo?.loyalty_organization_name,
      event: "click",
      pathname: window.location.pathname,
      userId: state?.userInfo?.user_id,
      role_id:state?.userInfo?.role_id,
      allstate:state
    });
  
    try {
      let values;
      if (!(typeof states.is_active === 'boolean') && !states.filterRole) {
        return;
      }
      values = {
        loyaltyId: state.ALA?.loyalty_id,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      if (typeof states.is_active === 'boolean') {
        values = {
          ...values,
          is_active: states.is_active,
        };
      }
      if (states.filterRole) {
        values = {
          ...values,
          filterRole: states.filterRole,
        };
      }
  
      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await filter(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setFilterCard(false);
        setStates({ filter: true });
        dispatch({ type: 'SET_LOADING', payload: false });
      } else {
        setFilterCard(false);
      }
    } catch (e) {
      console.log({ e });
    }
  };
  

  // update api func

  const handleUpdate = async () => {
    try {
      if (updateObj.email) {
        let res = validateEmail(updateObj.email);
        if (!res) return setErrorText('Please Enter Valid Email');
      }
      let obj = {
        ...updateObj,
        loyaltyId: states.loyaltyId,
        userId: states.userId,
      };
      let res = await update(obj);
      if (res && res.type === 'success') {
        setStates({
          editId: '',
          isEdit: false,
          isActive: null,
          role: '',
          email: '',
          userName: '',
        });
        setData([
          ...data.slice(0, parseInt(states.editId)),
          {
            ...data[parseInt(states.editId)],
            ...res?.resValue,
          },
          ...data.slice(parseInt(states.editId) + 1),
        ]);
        setEditObj({});
        history.push('/dashboard/upload-success', {
          type: i18n.language == 'fr' ? res.french_message : res.message
        });
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };
  let tableHeading = ['Name', 'Email', 'Role', 'Status', ''];

  return (
    <React.Fragment>
      <Grid
        container
        className={classes.root}
        onClick={() => {
          filterCard == true && setFilterCard(false);
        }}
      >
        <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
          <CssTextField
            id='enterPassword'
            placeholder={t('Search for Name or Email')}
            type={'text'}
            variant='outlined'
            autoComplete='off'
            className={classes.searchInput}
            onKeyDown={blockInvalidCharForText}
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  {searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      className={classes.searchInputIcon}
                      onClick={() => {
                        setSearchValue('');
                        setOffset(1);
                        handleGetAuthorizedMembers();
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=''
                      width='20px'
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              e.target.value.replace(/\s+/g, '').length == 0
                ? setSearchValue('')
                : setSearchValue(e.target.value);
              if (e.target.value.length == 0) {
                handleGetAuthorizedMembers();
              }
            }}
            onClick={() => {
              setOffset(1);
            }}
          />
          <Button
            className={`${classes.filterBtn} dash-1-filter-btn`}
            onClick={() => {
              setFilterCard(!filterCard);
              if (!states.filter) {
                setStates({ is_active: '', filterRole: '' });
              }
              trackWithGTM({
                database: state?.userInfo?.loyalty_organization_name,
                event: "click",
                pathname: window.location.pathname,
                userId: state?.userInfo?.user_id,
                role_id:state?.userInfo?.role_id,
                allstate:state
              });
            }}
          >
            {t('Filter')}
            {states.filter && (
              <Badge
                badgeContent={count == 0 ? '' : count}
                classes={{ badge: classes.badge }}
                max={999}
              >
                {/* <FilterListIcon /> */}
              </Badge>
            )}
          </Button>
        </Grid>
      </Grid>

      {filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: 'right' }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={1}
                  className={classes.filterCardGridContainer}
                >
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    className={classes.filterCardGrid}
                    style={{ padding: '5px 10px 10px 15px' }}
                  >
                    <TextField
                      id={'Status'}
                      label={t('Status')}
                      select
                      fullWidth
                      type={'text'}
                      value={states.is_active}
                      onChange={(e) => {
                        setStates({ is_active: e.target.value });
                      }}
                    >
                      <MenuItem value={true}>{t('Active')}</MenuItem>
                      <MenuItem value={false}>{t('InActive')}</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    className={classes.filterCardGrid}
                    style={{ padding: '5px 10px 10px 10px' }}
                  >
                    <TextField
                      id={'Role'}
                      label={t('Role')}
                      select
                      fullWidth
                      type={'text'}
                      value={states.filterRole}
                      onChange={(e) => {
                        setStates({ filterRole: e.target.value });
                      }}
                    >
                      {states.roles &&
                        states.roles.length > 0 &&
                        states.roles.map((r, i) => (
                          <MenuItem value={r.role_name} key={i}>
                            {t(r.role_name)}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    className={classes.filterCardBtnGrid}
                    style={{ padding: 10 }}
                  >
                    <Button
                      className={classes.filterCardApplyBtn}
                      style={{
                        fontSize: 15,
                        height: 35,
                        marginTop: 0,
                      }}
                      onClick={() => {
                        if (
                          !(typeof states.is_active === 'boolean') &&
                          !states.filterRole
                        ) {
                          toast.error('Please select any one of the fields', {
                            toastId: 'filter-empty',
                          });
                          return;
                        }
                        setSearchValue('');
                        // if (offset === 1) {

                        // }
                        handleFilter();
                        setOffset(1);
                        setCount(0);
                      }}
                    >
                      {t('Apply')}
                    </Button>
                    {states.filter && (
                      <Button
                        className={classes.filterCardResetBtn}
                        onClick={() => {
                          setStates({
                            filter: false,
                            is_active: '',
                            filterRole: '',
                          });
                          setFilterCard(false);
                          if (offset === 1) {
                            handleGetAuthorizedMembers();
                          } else {
                            setOffset(1);
                          }
                        }}
                      >
                        {t('Reset')}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      <Loader Loading={state.loading} top={'15%'}>
        <Grid className={classes.tableDownInResponsive}>
          <Grid xs={12} sm={12} lg={12}>
            <Table
              headings={tableHeading.map((i) => (
                <div
                  key={t(i)}
                  style={
                    i === 'Name'  || i === 'Email' ? { width: '200px'} : {}
                  }
                >
                  {t(i)}
                </div>
              ))}
              data={
                data &&
                data.length > 0 &&
                data.map((p, i) => [
                  [
                    states.editId === i && states.isEdit ? (
                      <div style={{ display: "flex", gap: "10px", width: "100%" }}>
                        <CssTextField
                          variant="outlined"
                          label={'First Name'}
                          style={{ width: "45%" }}
                          value={editObj?.firstName}
                          onChange={(e) => {
                            setEditObj({ ...editObj, firstName: e.target.value });
                            setUpdateObj({
                              ...updateObj,
                              firstName: e.target.value,
                            });
                          }}
                          helperText={errorText}
                          error={errorText.length > 0}
                        />
 
                        <CssTextField
                          variant="outlined"
                          label={'Last Name'}
                          style={{ width: "45%" }}
                          value={editObj?.lastName}
                          onChange={(e) => {
                            setEditObj({ ...editObj, lastName: e.target.value });
                            setUpdateObj({
                              ...updateObj,
                              lastName: e.target.value,
                            });
                          }}
                          helperText={errorText}
                          error={errorText.length > 0}
                        />
                      </div>
                    ) : (
                      // Display First Name and Last Name side by side in non-edit mode
                      <div style={{ display: "flex", gap: "5px" }}>
                        <span>{p?.["User.first_name"] ? p["User.first_name"] : "null"}</span>
                        <span>{p?.["User.last_name"] ? p["User.last_name"] : "null"}</span>
                      </div>
                    ),
                  ],
                
              
                  

                  [
                    states.editId === i && states.isEdit ? (
                      <CssTextField
                        variant='outlined'
                        label={'Email'}
                        style={{ width: '90%' }}
                        type={'email'}
                        value={editObj?.email}
                        onChange={(e) => {
                          setEditObj({ ...editObj, email: e.target.value });
                          setUpdateObj({
                            ...updateObj,
                            email: e.target.value,
                          });
                        }}
                        helperText={errorText}
                        error={errorText.length > 0 ? true : false}
                      />
                    ) : (
                      p?.['User.email']
                    ),
                  ],

                  [
                    states.editId === i && states.isEdit ? (
                      <TextField
                        id={'Role'}
                        label={'Role'}
                        select
                        style={{ width: '90%' }}
                        type={'text'}
                        value={editObj?.role}
                        onChange={(e) => {
                          setEditObj({ ...editObj, role: e.target.value });
                          setUpdateObj({
                            ...updateObj,
                            role: e.target.value,
                            userName:
                          p?.['User.first_name'] +''+
                         
                             p?.['User.last_name'],
                          });
                        }}
                      >
                        {states.roles.length > 0 &&
                          states.roles.map((r, i) => (
                            <MenuItem value={r.role_name}>
                              {t(r.role_name)}
                            </MenuItem>
                          ))}
                        {addRoles(states.roles, p?.['HS_Role.role_name'])}
                      </TextField>
                    ) : (
                      t(p?.['HS_Role.role_name'])
                    ),
                  ],

                  [
                    parseInt(states.editId) === i && states.isEdit ? (
                      <CssTextField
                        variant='outlined'
                        label='Active'
                        select
                        fullWidth
                        style={{ width: '90%' }}
                        value={editObj?.isActive}
                        onChange={(e) => {
                          setEditObj({ ...editObj, isActive: e.target.value });
                          setUpdateObj({
                            ...updateObj,
                            isActive: e.target.value,
                          });
                        }}
                      >
                        <MenuItem value={true}>{t('Active')}</MenuItem>
                        <MenuItem value={false}>{t('InActive')}</MenuItem>
                      </CssTextField>
                    ) : p?.['is_active'] ? (
                      <span style={{ color: 'green' }} key={i}>
                        {t('Active')}
                      </span>
                    ) : p?.['is_active'] != null ? (
                      <span style={{ color: 'red' }} key={i}>
                        {'InActive'}
                      </span>
                    ) : null,
                  ],
                  [
                    parseInt(states.editId) === i && states.isEdit ? (
                      <React.Fragment>
                        <CheckCircleOutlineIcon
                          style={{
                            cursor: 'pointer',
                            color: 'green',
                            margin: '0px 5px',
                            fontSize: 35,
                          }}
                          onClick={() => {
                            if (
                              p?.['User.first_name']=== editObj.firstName &&
                              p?.['User.last_name']=== editObj.lastName &&
                              p?.['HS_Role.role_name'] === editObj.role &&
                              p?.['User.email'] === editObj.email &&
                              p?.['is_active'] === editObj.isActive
                            ) {
                              return toast.error('Please update an value', {
                                toastId: 'same-data-authorizedMembers',
                              });
                            }

                            if (
                              p?.['User.email']?.length > 0 &&
                              updateObj?.email?.length == 0
                            ) {
                              return setErrorText('Please Enter Valid Email');
                            }
                            handleUpdate();
                          }}
                        />
                        <HighlightOffIcon
                          style={{
                            cursor: 'pointer',
                            color: 'red',
                            margin: '0px 5px',
                            fontSize: 35,
                          }}
                          onClick={() => {
                            setStates({
                              editId: '',
                              isEdit: false,
                              isActive: '',
                              role: '',
                              email: '',
                              firstName: '',
                              lastName:''
                            });
                            setEditObj({});
                            setErrorText('');
                          }}
                        />
                      </React.Fragment>
                    ) : (
                      (state.userInfo?.role === 'Loyalty Admin' ||
                        (state.userInfo?.role === 'FSC' &&
                          state.userInfo?.user_id !== p?.['User.user_id']) ||
                        access['authorizedMembers']['admins'][
                        state.userInfo.role
                        ]) && (
                        <div
                          style={{ cursor: 'pointer' }}
                          aria-disabled={!state?.userInfo?.editAccess}
                          onClick={() => {
                            if (state?.userInfo?.editAction) {
                              setStates({
                                editId: '',
                                isEdit: false,
                                isActive: '',
                                role: '',
                              });
                              setEditObj({});
                              setStates({
                                editId: i,
                                isEdit: true,
                                isActive: p?.['is_active'],
                                role: p?.['HS_Role.role_name'],
                                userId: p?.['User.user_id'],
                                loyaltyId: p?.['loyalty_id'],
                                email: p?.['User.email'],
                                firstName:p?.['User.first_name'],
                                lastName:p?.['User.last_name']
                                
                              });
                              setEditObj({
                                ...editObj,
                                firstName:p?.['User.first_name'],
                                lastName:p?.['User.last_name'],
                                isActive: p?.['is_active'],
                                role: p?.['HS_Role.role_name'],
                                email: p?.['User.email'],
                              });
                              return;
                            } else {
                              toast.error(state.userInfo?.editAccess)
                              return;
                            }
                          }
                          }
                        >
                          <img src={editIcon} alt='' width='20' />
                        </div>
                      )
                    ),
                  ],
                ])
              }
              offset={offset}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
            />
          </Grid>
        </Grid>
      </Loader>
    </React.Fragment>
  );
}
